import Boxes from '../Assets/General/Boxes.svg';
import Logo from '../Assets/General/Logo.svg';
import Storage from '../Assets/General/Storage.svg';
import EmptyBox from '../Assets/General/EmptyBox.svg';
import RequestActive from '../Assets/General/RequestActive.svg';
import Request from '../Assets/General/Request.svg';
import HistoryActive from '../Assets/General/HistoryActive.svg';
import History from '../Assets/General/History.svg';
import Message from '../Assets/General/Message.svg';
import Tracking from '../Assets/General/Tracking.svg';
import NoResult from '../Assets/General/NoResult.svg';
import BoxesActive from '../Assets/General/BoxesActive.svg';
import BoxInactive from '../Assets/General/BoxInactive.svg';
import Boxpack from '../Assets/General/Boxpack.svg';
import Pickup from '../Assets/General/Pickup.svg';
import Indelivery from '../Assets/General/Indelivery.svg';
import AllCheck from '../Assets/General/AllCheck.svg';
import AllCheckActive from '../Assets/General/AllCheckActive.svg';
import Calendar from '../Assets/General/Calendar.svg';
import CalendarActive from '../Assets/General/CalendarActive.svg';
import DataCheck from '../Assets/General/DataCheck.svg';
import DataCheckActive from '../Assets/General/DataCheckActive.svg';
import DataCheckActive2 from '../Assets/General/DataCheckActive2.svg';
import WarehouseDrop from '../Assets/General/WarehouseDrop.svg';
import PersonActive from '../Assets/General/PersonActive.svg';
import Divider from '../Assets/General/Divider.svg';
import Write from '../Assets/General/Write.svg';
import Delivery from '../Assets/General/Delivery.svg';
import DeliveryActive from '../Assets/General/DeliveryActive.svg';
import RequestIn from '../Assets/General/RequestIn.svg';
import RequestInOrange from '../Assets/General/RequestInOrange.svg';
import Onboarding from '../Assets/General/Onboarding.png';
import HomeDropOrange from '../Assets/General/HomeDropOrange.svg';
import ShoppingBag from '../Assets/General/ShoppingBag.svg';
import RequestOutOrange from '../Assets/General/RequestOutOrange.svg';
import WarehouseDropOrange from '../Assets/General/WarehouseDropOrange.svg';
import PickupOrange from '../Assets/General/PickupOrange.svg';
import InDeliveryOrange from '../Assets/General/InDeliveryOrange.svg';
import DoneOrange from '../Assets/General/DoneOrange.svg';
import CanceledOrange from '../Assets/General/CanceledOrange.svg';
import RequestOut from '../Assets/General/RequestOut.svg';
import SideWave from '../Assets/General/SideWave.svg';
import WaveCard from '../Assets/General/WaveCard.svg';
import LinearBg from '../Assets/General/LinearBg.svg';
import LinearBg2 from '../Assets/General/LinearBg.png';
import Profile from '../Assets/General/Profile.svg';
import ProfileActive from '../Assets/General/ProfileActive.svg';
import Market from '../Assets/General/Market.svg';
import MarketActive from '../Assets/General/MarketActive.svg';
import LongDivider from '../Assets/General/LongDivider.svg';
import SafetyGuarantee from '../Assets/General/SafetyGuarantee.svg';
import MarketBlack from '../Assets/General/MarketBlack.svg';
import Valid from '../Assets/General/Valid.svg';
import Icon from '../Assets/General/Icon.svg';
import Check from '../Assets/General/Check.svg';
import CheckRed from '../Assets/General/CheckRed.svg';
import Check2 from '../Assets/General/Check2.svg';
import SafetyIcon from '../Assets/General/SafetyIcon.svg';
import ConfidentalIcon from '../Assets/General/ConfidentalIcon.svg';
import VerifiedIcon from '../Assets/General/VerifiedIcon.svg';
import NormalStar from '../Assets/General/NormalStar.svg';
import PremiumStar from '../Assets/General/PremiumStar.svg';
import Inbox from '../Assets/General/Inbox.svg';
import Sure from '../Assets/General/Sure.svg';
import Setting from '../Assets/General/Setting.svg';
import Address from '../Assets/General/Address.svg';
import TodaysRequest from '../Assets/General/TodaysRequest.svg';
import AvailableStorages from '../Assets/General/AvailableStorages.svg';
import AvailableCouriers from '../Assets/General/AvailableCouriers.svg';
import TotalMarket from '../Assets/General/TotalMarket.svg';
import Requests from '../Assets/General/Requests.svg';
import Ongoing from '../Assets/General/Ongoing.svg';
import Finish from '../Assets/General/Finish.svg';
import RequestInActive2 from '../Assets/General/RequestInActive2.svg';
import RequestOutRounded2 from '../Assets/General/RequestOutRounded2.svg';
import RequestOutRounded from '../Assets/General/RequestOutRounded.svg';
import WarehouseValidate from '../Assets/General/WarehouseValidate.svg';
import RequestInRounded2 from '../Assets/General/RequestInRounded2.svg';
import NoCourierTask from '../Assets/General/NoCourierTask.svg';
import ConfirmationActive2 from '../Assets/General/ConfirmationActive2.svg';
import Confirmation from '../Assets/General/Confirmation.svg';
import DeliveryActive2 from '../Assets/General/DeliveryActive2.svg';
import Courier from '../Assets/General/Courier.svg';
import RequestInRounded from '../Assets/General/RequestInRounded.svg';
import PhoneOrange from '../Assets/General/PhoneOrange.svg';
import LocationOrange from '../Assets/General/LocationOrange.svg';
import WarehouseValidateActive from '../Assets/General/WarehouseActive.svg';
import WarehouseValidateActive2 from '../Assets/General/WarehouseValidateActive2.svg';
import LinePoint from '../Assets/General/LinePoint.svg';
import LinePointActive from '../Assets/General/LinePointActive.svg';
import EmptyBox2 from '../Assets/General/EmptyBox2.svg';
import Dollar from '../Assets/General/Dollar.svg';
import DollarActive2 from '../Assets/General/DollarActive2.svg';
import Revenue from '../Assets/General/Revenue.svg';
import TotalTransactions from '../Assets/General/TotalTransactions.svg';
import FixedPrice from '../Assets/General/FixedPrice.svg';
import BidPrice from '../Assets/General/BidPrice.svg';
import CheckRounded from '../Assets/General/CheckRounded.svg';
import RequestOutActive2 from '../Assets/General/RequestOutActive2.svg';
import CustomerDrop from '../Assets/General/CustomerDrop.svg';
import CustomerDropActive from '../Assets/General/CustomerDropActive.svg';
import TimeLeft from '../Assets/General/TimeLeft.svg';
import SubscriptionRounded from '../Assets/General/SubscriptionRounded.svg';
import RunOut from '../Assets/General/RunOut.svg';
import MyProfile from '../Assets/General/MyProfile.svg';
import LogoWhite from '../Assets/General/LogoWhite.svg';
import MyBalance from '../Assets/General/MyBalance.svg';
import MyStorage from '../Assets/General/MyStorage.svg';
import TestImg from '../Assets/General/TestImg.svg';
import Twitter from '../Assets/General/Twitter.svg';
import Facebook from '../Assets/General/Facebook.svg';
import Linkedin from '../Assets/General/Linkedin.svg';
import Instagram from '../Assets/General/Instagram.svg';
import ArrowBack from '../Assets/General/ArrowBack.svg';
import Info from '../Assets/General/Info.svg';
import Success from '../Assets/General/Success.svg';
import OenoStorage from '../Assets/General/OneoStorage.svg';
import OenoMarket from '../Assets/General/OneoMarket.svg';
import OenoGuarantee from '../Assets/General/OneoGuarantee.svg';
import OenoIn from '../Assets/General/OneoIn.svg';
import OenoOut from '../Assets/General/OneoOut.svg';
import IconRequestIn from '../Assets/General/IconRequestIn.svg';
import IconPolicy from '../Assets/General/IconPolicy.svg';
import IconHistory from '../Assets/General/IconHistory.svg';
import IconSubscription from '../Assets/General/IconSubscription.svg';
import IconDetailItem from '../Assets/General/IconDetailItem.svg';
import IconLocation from '../Assets/General/IconLocation.svg';
import IconConfirmation from '../Assets/General/IconConfirmation.svg';
import IconHelp from '../Assets/General/IconHelp.svg';
import IconSettings from '../Assets/General/IconSettings.svg';
import IconMail from '../Assets/General/IconMail.svg';
import IconSignout from '../Assets/General/IconSignout.svg';
import IconPrivacy from '../Assets/General/IconPrivacy.svg';
import IconInfoRounded from '../Assets/General/IconInfoRounded.svg';
import IconOeno from '../Assets/General/IconOneo.svg';
import IconSecurity from '../Assets/General/IconSecurity.svg';
import InfoRed from '../Assets/General/InfoRed.svg';
import IconDelivery from '../Assets/General/IconDelivery.svg';
import IconHome from '../Assets/General/IconHome.svg';
import OenoTopup from '../Assets/General/OneoTopup.svg';
import OenoWithdraw from '../Assets/General/OneoWithdraw.svg';
import OenoHelp from '../Assets/General/OneoHelp.svg';
import OenoBag from '../Assets/General/OneoBag.svg';
import OenoHammer from '../Assets/General/OneoHammer.svg';
import OenoWallet from '../Assets/General/OneoWallet.svg';
import OenoBox from '../Assets/General/OneBox.svg';
import OenoCanceled from '../Assets/General/OneoCanceled.svg';
import OenoCurrency from '../Assets/General/OneoCurrency.svg';
import OenoPeople from '../Assets/General/OneoPeople.svg';
import OenoShipping from '../Assets/General/OneoShipping.svg';
import OenoTopup2 from '../Assets/General/OneoTopup2.svg';
import OenoWithdraw2 from '../Assets/General/OneoWithdraw2.svg';
import Download from '../Assets/General/Download.svg';
import Euro from '../Assets/General/Euro.svg';
import BoxOutlined from '../Assets/General/BoxOutlined.svg';
import Trash from '../Assets/General/Trash.svg';
import Edit from '../Assets/General/Edit.svg';
import BottleLayer from '../Assets/General/BottleLayer.png';

const Images = {
  Boxes,
  Logo,
  Storage,
  EmptyBox,
  RequestActive,
  Request,
  HistoryActive,
  History,
  Message,
  Tracking,
  NoResult,
  BoxesActive,
  BoxInactive,
  Boxpack,
  Pickup,
  Indelivery,
  AllCheck,
  AllCheckActive,
  Calendar,
  CalendarActive,
  DataCheck,
  DataCheckActive,
  DataCheckActive2,
  WarehouseDrop,
  PersonActive,
  Divider,
  Write,
  Setting,
  CheckRed,
  Delivery,
  DeliveryActive,
  RequestIn,
  RequestInOrange,
  Onboarding,
  HomeDropOrange,
  ShoppingBag,
  RequestOutOrange,
  WarehouseDropOrange,
  PickupOrange,
  InDeliveryOrange,
  DoneOrange,
  CanceledOrange,
  RequestOut,
  SideWave,
  WaveCard,
  LinearBg,
  LinearBg2,
  Profile,
  ProfileActive,
  Market,
  MarketActive,
  LongDivider,
  SafetyGuarantee,
  MarketBlack,
  Valid,
  Icon,
  Check,
  Check2,
  SafetyIcon,
  ConfidentalIcon,
  VerifiedIcon,
  NormalStar,
  PremiumStar,
  Inbox,
  Sure,
  Address,
  TodaysRequest,
  AvailableStorages,
  AvailableCouriers,
  TotalMarket,
  Requests,
  Ongoing,
  Finish,
  RequestInActive2,
  RequestOutRounded2,
  RequestOutRounded,
  WarehouseValidate,
  RequestInRounded2,
  NoCourierTask,
  ConfirmationActive2,
  Confirmation,
  DeliveryActive2,
  CourierActive2: DeliveryActive2,
  Courier,
  RequestInRounded,
  PhoneOrange,
  LocationOrange,
  WarehouseValidateActive,
  WarehouseValidateActive2,
  LinePoint,
  LinePointActive,
  EmptyBox2,
  Dollar,
  DollarActive2,
  Revenue,
  TotalTransactions,
  FixedPrice,
  BidPrice,
  CheckRounded,
  RequestOutActive2,
  CustomerDrop,
  CustomerDropActive,
  TimeLeft,
  SubscriptionRounded,
  RunOut,
  MyProfile,
  LogoWhite,
  MyBalance,
  MyStorage,
  TestImg,
  Twitter,
  Facebook,
  Linkedin,
  Instagram,
  ArrowBack,
  Info,
  Success,
  OenoStorage,
  OenoMarket,
  OenoGuarantee,
  OenoIn,
  OenoOut,
  OenoTopup,
  OenoWithdraw,
  OenoHelp,
  OenoBag,
  OenoHammer,
  OenoWallet,
  OenoBox,
  OenoCanceled,
  OenoCurrency,
  OenoPeople,
  OenoShipping,
  OenoTopup2,
  OenoWithdraw2,
  Download,
  Euro,
  BoxOutlined,
  Trash,
  Edit,
  BottleLayer,
  IconRequestIn,
  IconPolicy,
  IconHistory,
  IconSubscription,
  IconDetailItem,
  IconLocation,
  IconConfirmation,
  IconHelp,
  IconSettings,
  IconMail,
  IconSignout,
  IconPrivacy,
  IconInfoRounded,
  IconOeno,
  IconSecurity,
  InfoRed,
  IconDelivery,
  IconHome,
};

export default Images;
